'use strict';

var _draftJs = require('draft-js');

var _draftToHTML = require('./draftToHTML');

var _draftToHTML2 = _interopRequireDefault(_draftToHTML);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Function returns collection of currently selected blocks.
*/
// @file: util functions file
// @auth: spc@data.me 2017/10/12
function getSelectedBlocksList(editorState) {
    var selectionState = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var startKey = selectionState.getStartKey();
    var endKey = selectionState.getEndKey();
    var blockMap = contentState.getBlockMap();
    return blockMap.toSeq().skipUntil(function (_, key) {
        return key === startKey;
    }).takeUntil(function (_, key) {
        return key === endKey;
    }).concat([[endKey, blockMap.get(endKey)]]).toList();
}

/**
* Function returns collection of currently selected blocks.
*/
function getSelectedBlocksMap(editorState) {
    var selectionState = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var startKey = selectionState.getStartKey();
    var endKey = selectionState.getEndKey();
    var blockMap = contentState.getBlockMap();
    return blockMap.toSeq().skipUntil(function (_, key) {
        return key === startKey;
    }).takeUntil(function (_, key) {
        return key === endKey;
    }).concat([[endKey, blockMap.get(endKey)]]);
}

/**
* Function will return currently selected text in the editor.
*/
function getSelectionText(editorState) {
    var selectedText = '';
    var selectionState = editorState.getSelection();
    var startKey = selectionState.getAnchorOffset();
    var endKey = selectionState.getFocusOffset();
    var selectedBlocks = getSelectedBlocksList(editorState);
    if (selectedBlocks.size > 0) {
        if (selectionState.getIsBackward()) {
            var tempKey = startKey;
            startKey = endKey;
            endKey = tempKey;
        }
        selectedText = selectedBlocks.map(function (block, index) {
            console.log(block.getText());
            var start = 0;
            var end = block.getText().length;
            if (index === 0) {
                start = startKey;
            }
            if (index === selectedBlocks.size - 1) {
                end = endKey;
            }
            return block.getText().slice(start, end);
        }).join('');
    }
    return selectedText;
}

// /**
// * Function will return inlineStyle of currently selected text in the editor.
// */
// function getSelectedBlocksStyle(editorState) {
//     const inlineStyles = {
//         BOLD: true,
//         ITALIC: true,
//         UNDERLINE: true,
//         STRIKETHROUGH: true,
//         CODE: true,
//         SUPERSCRIPT: true,
//         SUBSCRIPT: true
//     };
//     const currentSelection = editorState.getSelection();
//     const start = currentSelection.getStartOffset();
//     const end = currentSelection.getEndOffset();
//     const selectedBlocks = getSelectedBlocksList(editorState);
//     if (selectedBlocks.size > 0) {
//       for (let i = 0; i < selectedBlocks.size; i += 1) {
//         let blockStart = i === 0 ? start : 0;
//         let blockEnd =
//           i === (selectedBlocks.size - 1) ? end : selectedBlocks.get(i).getText().length;
//         if (blockStart === blockEnd && blockStart === 0) {
//           blockStart = 1;
//           blockEnd = 2;
//         } else if (blockStart === blockEnd) {
//           blockStart -= 1;
//         }
//         for (let j = blockStart; j < blockEnd; j += 1) {
//             const inlineStylesAtOffset = selectedBlocks.get(i).getInlineStyleAt(j);
//                ['BOLD', 'ITALIC', 'UNDERLINE', 'STRIKETHROUGH', 'CODE', 'SUPERSCRIPT', 'SUBSCRIPT'].forEach((style) => {
//                   inlineStyles[style] = inlineStyles[style] && inlineStylesAtOffset.get(style) === style;
//                   });
//             }
//       }
//     }
//     return inlineStyles;
// }

/*
Get currentBlock in the editorState.
*/
function getCurrentBlock(editorState) {
    var selectionState = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var block = contentState.getBlockForKey(selectionState.getStartKey());
    return block;
}

/**
* Function will change block level meta-data.
*/
function setBlockData(editorState, data) {
    var newContentState = _draftJs.Modifier.setBlockData(editorState.getCurrentContent(), editorState.getSelection(), data);
    return _draftJs.EditorState.push(editorState, newContentState, 'change-block-data');
}

/**
* Function will render block style by meta-data.
*/
function blockStyleFunc(block) {
    var blockAlignment = block.getData() && block.getData().get('text-align');
    if (blockAlignment) {
        return 'rde-text-align-' + blockAlignment;
    }
    return '';
}

module.exports = {
    stateToHTML: _draftToHTML2.default,
    blockStyleFunc: blockStyleFunc,
    setBlockData: setBlockData,
    getCurrentBlock: getCurrentBlock,
    getSelectionText: getSelectionText
};


//////////////////
// WEBPACK FOOTER
// ./js/src/utils/index.js
// module id = 17
// module chunks = 0